<template>
  <div class="wrapper-box" v-animate-on-scroll="'fade-up'">
    <div class="title">
      <img class="title-img" src="./img/title-left-icon.png" alt="">
      <div>{{ title }}</div>
      <img class="title-img" src="./img/title-left-icon.png" style="transform: rotate(180deg);" alt="">
    </div>
    <div class="en-title" v-if="enTitle">{{ enTitle }}</div>
    <div v-if="isShowBottomImg">
      <img class="title-bottom-img" src="./img/title-bottom-icon.png" alt="">
    </div>

    <div class="wrapper-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wrapper-box',
  props: {
    title: {
      type: String,
      default: ''
    },
    enTitle: {
      type: String,
      default: ''
    },
    isShowBottomImg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/style/var.scss';
.wrapper-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    display: flex;
    align-items: center;
    font-size: 40px;
    font-weight: bold;
    color: $primary-color;
    .title-img {
      width: 43px;
      height: 29px;
      margin: 0 12px;
    }
  }
  .en-title{
    font-size: 28px;
    font-weight: 400;
    color: $primary-color;
    margin-top: 10px;
  }

  .title-bottom-img {
    width: 85px;
    height: 91px;
    margin-top: 24px;
    margin-bottom: 64px;
  }

  .wrapper-content{
    width: 100%;
    height: 100%;
  }
}
</style>
